import { TableColumn } from './types'

export const INVENTORY_VIEW_OPTIONS = [
  {
    label: 'In the yard',
    value: 'ingate',
  },
  // Not available in the current version
  // {
  //   label: 'Outgated',
  //   value: 'outgate',
  // },
]

export const TABLE_COLUMNS_OPTIONS: TableColumn[] = [
  {
    label: 'Asset type',
    value: 'assetType',
    type: 'general',
    sortable: false,
  },
  {
    label: 'Ingate date/time',
    value: 'DATE',
    type: 'general',
    sortable: true,
  },
  {
    label: 'Load number',
    value: 'loadNumber',
    type: 'load',
    sortable: true,
  },
  {
    label: 'Seal',
    value: 'hasSeal',
    type: 'load',
    sortable: false,
  },
  {
    label: 'Seal number',
    value: 'sealNumber',
    type: 'load',
    sortable: true,
  },
  {
    label: 'Load LP',
    value: 'loadLicensePlate',
    type: 'load',
    sortable: false,
  },
  {
    label: 'Load damage',
    value: 'loadDamage',
    type: 'load',
    sortable: false,
  },
  {
    label: 'Load remarks',
    value: 'loadRemarks',
    type: 'load',
    sortable: false,
  },
  {
    label: 'Chassis number',
    value: 'chassisNumber',
    type: 'chassis',
    sortable: false,
  },
  {
    label: 'Chassis LP',
    value: 'chassisLicensePlate',
    type: 'chassis',
    sortable: false,
  },
  {
    label: 'Chassis damage',
    value: 'chassisDamage',
    type: 'chassis',
    sortable: false,
  },
  {
    label: 'Chassis remarks',
    value: 'chassisRemarks',
    type: 'chassis',
    sortable: false,
  },
  {
    label: 'Carrier',
    value: 'vehicleCarrierName',
    type: 'tractor',
    sortable: true,
  },
  {
    label: 'Truck number',
    value: 'vehicleNumber',
    type: 'tractor',
    sortable: false,
  },
  {
    label: 'Truck remarks',
    value: 'vehicleRemarks',
    type: 'tractor',
    sortable: false,
  },
  {
    label: 'Fuel type',
    value: 'vehicleFuelType',
    type: 'tractor',
    sortable: true,
  },
  {
    label: 'Truck DOT',
    value: 'vehicleDotNumber',
    type: 'tractor',
    sortable: false,
  },
  {
    label: 'Truck LP',
    value: 'vehicleLicensePlate',
    type: 'tractor',
    sortable: false,
  },
  {
    label: 'Truck damage',
    value: 'vehicleDamage',
    type: 'tractor',
    sortable: false,
  },
  {
    label: 'Truck class',
    value: 'vehicleWeightClass',
    type: 'tractor',
    sortable: true,
  },
]

export const DEFAULT_COLUMNS: TableColumn[] = [
  {
    label: 'Asset type',
    value: 'assetType',
    type: 'general',
    sortable: false,
  },
  {
    label: 'Ingate date/time',
    value: 'DATE',
    type: 'general',
    sortable: true,
  },
  {
    label: 'Dwell time',
    value: 'vehicleDwellTimeHr',
    type: 'general',
    sortable: true,
  },
  {
    label: 'Truck number',
    value: 'vehicleNumber',
    type: 'tractor',
    sortable: false,
  },
  {
    label: 'Carrier',
    value: 'vehicleCarrierName',
    type: 'tractor',
    sortable: true,
  },
  {
    label: 'Chassis number',
    value: 'chassisNumber',
    type: 'chassis',
    sortable: false,
  },
  {
    label: 'Load number',
    value: 'loadNumber',
    type: 'load',
    sortable: true,
  },
  {
    label: 'Fuel type',
    value: 'vehicleFuelType',
    type: 'tractor',
    sortable: true,
  },
]

export const TRUCK_CLASS_OPTIONS = [
  {
    label: 'Class 1',
    value: '1',
  },
  {
    label: 'Class 2a',
    value: '2a',
  },
  {
    label: 'Class 2a',
    value: '2b',
  },
  {
    label: 'Class 3',
    value: '3',
  },
  {
    label: 'Class 4',
    value: '4',
  },
  {
    label: 'Class 5',
    value: '5',
  },
  {
    label: 'Class 6',
    value: '6',
  },
  {
    label: 'Class 7',
    value: '7',
  },
  {
    label: 'Class 8',
    value: '8',
  },
]

export const TRUCK_FUEL_TYPE_OPTIONS = [
  {
    label: 'D - Diesel',
    value: 'D',
  },
  {
    label: 'NZE - Near Zero Emission',
    value: 'NZE',
  },
  {
    label: 'ZE - Zero Emission',
    value: 'ZE',
  },
]

export const ROW_TRUCK_FUEL_TYPE_OPTIONS = [
  {
    label: 'Diesel',
    value: 'D',
  },
  {
    label: 'Near Zero Emission',
    value: 'NZE',
  },
  {
    label: 'Zero Emission',
    value: 'ZE',
  },
  {
    label: 'CNG',
    value: 'CNG',
  },
]

export const TABLE_FILTER_OPTIONS = [
  { label: 'Carrier name', value: 'vehicle.carrier.name', category: 'general' },
  { label: 'Load #', value: 'load.number', category: 'load' },
  { label: 'Load License Plate #', value: 'load.licensePlate', category: 'load' },
  { label: 'Load type', value: 'load.type.name', category: 'load' },
  { label: 'Chassis #', value: 'chassis.number', category: 'chassis' },
  { label: 'Chassis License Plate #', value: 'chassis.licensePlate', category: 'chassis' },
  { label: 'Vehicle Truck #', value: 'vehicle.number', category: 'vehicle' },
  { label: 'Vehicle DOT #', value: 'vehicle.dotNumber', category: 'vehicle' },
  { label: 'Vehicle Class', value: 'vehicle.weightClass', category: 'vehicle' },
  { label: 'Vehicle Fuel Type', value: 'vehicle.fuelType', category: 'vehicle' },
  { label: 'Vehicle License Plate #', value: 'vehicle.licensePlate', category: 'vehicle' },
  { label: 'Vehicle Type', value: 'vehicle.type.name', category: 'vehicle' },
]

export const REQUIRED_FIELD_MESSAGE = 'This field is required'

export const ALL_ASSETS = 'all_assets'
